<div class="modais-wrapper" [class.duas-modais]="comprovanteVisualizado">
    <div class="modal-comprovantes">
        <div class="modal-comprovantes-conteudo">
            <div class="modal-comprovantes-header">
                <span>Comprovantes</span>
                <button class="btn-close" (click)="fecharModalComprovantes()"><img src="assets/img/icons/close-white.svg" alt=""></button>
            </div>

            <div class="container">
                <div class="label">
                    Clientes com comprovante disponivel para download:
                </div>

                <div class="listas-container clientes-selecionados">
                    <ul>
                        <li>
                            <div class="d-flex cabecalho">
                                <div class="title">
                                    <input 
                                        type="checkbox" 
                                        class="checkbox-accent"
                                        [(ngModel)]="todosSelecionados"
                                        (change)="toggleTodos($event)"
                                        />
                                    <span>Clientes</span>
                                </div>
                                
                                <div>
                                    <span style="margin-right: 45px;">Comprovantes</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="d-flex">
                        <!-- Lista da esquerda (clientes) -->
                        <ul >
                            <li *ngFor="let item of entregasPossuiConfirmacao; let i = index"
                                (click)="entregasComComprovante[i] && abrirVisualizacaoComprovante(item, entregasComComprovante[i])"
                                [class.cursor-pointer]="entregasComComprovante[i]"
                                [attr.data-tooltip]="entregasComComprovante[i] ? 'Visualizar comprovante' : 'Carregando comprovante...'"
                                data-tooltip-pos="top">
                                <div class="clientes">
                                    <input
                                    type="checkbox"
                                    [checked]="isSelecionado(item)"
                                    (change)="toggleSelecao(item, $event)"
                                    class="checkbox-accent"
                                    />
                                    <span>
                                    {{ configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia?  item.NomeFantasia.length > 22 ? (item.NomeFantasia | slice:0:22) + '...' : item.NomeFantasia  :  item.RazaoSocial.length > 22 ? (item.RazaoSocial | slice:0:22) + '...' : item.RazaoSocial }}
                                    </span>
                                </div>
                            </li>
                        </ul>

                        <!-- Lista da direita (imagens) -->
                        <ul class="p-0">
                            <li *ngFor="let item of entregasPossuiConfirmacao; let i = index"
                                (click)="entregasComComprovante[i] && abrirVisualizacaoComprovante(item, entregasComComprovante[i])"
                                [class.cursor-pointer]="entregasComComprovante[i]"
                                [attr.data-tooltip]="entregasComComprovante[i] ? 'Visualizar comprovante' : 'Carregando comprovante...'"
                                data-tooltip-pos="top">

                                <div class="lista-comprovantes d-flex justify-content-start">
                                    <ng-container *ngIf="entregasComComprovante[i]; else carregando">
                                        <img
                                            style="height: 38px;"
                                            width="32"
                                            src="data:image/jpeg;base64,{{ entregasComComprovante[i].imagem }}"
                                        />
                                    </ng-container>
                                    <ng-template #carregando>
                                        <div class="carregando-comprovantes">
                                            <div class="loader">
                                                <svg viewBox="0 0 36 36">
                                                    <circle class="bg" cx="18" cy="18" r="17"></circle>
                                                    <circle class="progress" cx="18" cy="18" r="17"></circle>
                                                </svg>
                                            </div>
                                        </div>
                                    </ng-template>
                                </div>
                            </li>
                        </ul>
                    </div>  
            </div>
            <div class="d-flex justify-content-end pt-4">
            <button 
                    class="btn-download" 
                    (click)="fazerDownload()" 
                    [disabled]="isDownloading" 
                    [class.btn-disabled]="isDownloading"
                    >
                    <img 
                        width="16px"
                        [src]="isDownloading 
                        ? 'assets/img/icons/download_comprovante-grey.svg' 
                        : 'assets/img/icons/download_comprovante.svg'"
                        alt="Ícone de download"
                    >
                    <span>Baixar comprovantes</span>
                </button>
            </div>
        </div>
        </div>
    </div>

    <div class="modal-visualizar-comprovante" *ngIf="comprovanteVisualizado">
        <div class="modal-visualizar-conteudo">

            <div class="modal-comprovantes-header">
                <span>Comprovante</span>
                <button class="btn-close" (click)="fecharVisualizacaoComprovante()">
                    <img src="assets/img/icons/close-white.svg" alt="Fechar">
                </button>
            </div>

            <div class="modal-visualizar-body">
                <p class="nome-cliente">
                    {{ configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia
                        ? comprovanteVisualizado.cliente.NomeFantasia
                        : comprovanteVisualizado.cliente.RazaoSocial }}
                </p>
                <img
                    class="imagem-comprovante-grande"
                    src="data:image/jpeg;base64,{{ comprovanteVisualizado.imagem }}"
                    alt="Comprovante"
                />
            </div>

            <div class="modal-visualizar-footer">
                <button class="btn-download" (click)="fazerDownloadIndividual(comprovanteVisualizado)">
                    <img width="16px" src="assets/img/icons/download_comprovante.svg" alt="Download">
                    <span>Download</span>
                </button>
            </div>

        </div>
    </div>



</div>



   




<div class="modal-confirm" *ngIf="abrirModalDownload">
    <div class="modal-conteudo">
        <div class="header-modal">
            <span class="ms-3 titulo-header">Download</span>
        </div>
       
        <div class="p-3 px-4">
            <div class="d-flex container-downloads">
                <ul>
                    <li *ngFor="let item of itensSelecionados; let i = index">
                        <div class="lista-downloads">
                            <div>
                                <span>
                                    {{configNomeClienteExibicao == enumConfiguracaoInfoCliente.NomeFantasia? item.NomeFantasia : item.RazaoSocial}}.pdf
                                </span>
                                <p *ngIf="item.statusDownload === 'baixando'" class="baixando">
                                    Baixando arquivo...
                                </p>

                                <p *ngIf="item.statusDownload === 'concluido'" class="concluido">
                                    Download concluído
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

